import outlineDepan from "../assets/vehicle-outline-depan.svg";
import outlineKiri from "../assets/vehicle-outline-kiri.svg";
import outlineKanan from "../assets/vehicle-outline-kanan.svg";
import outlineBelakang from "../assets/vehicle-outline-belakang.svg";
import boxOutlineDepan from "../assets/trailer-box-outline-depan.svg";
import boxOutlineKiri from "../assets/trailer-box-outline-kiri.svg";
import boxOutlineKanan from "../assets/trailer-box-outline-kanan.svg";
import boxOutlineBelakang from "../assets/trailer-box-outline-belakang.svg";

// generic front/left/right/rear vehicle outline shown in ImageCanvas as long as no photo (gambar_*) exists yet,
// so a marking can still be placed before the first photo is taken. gambar_box_* are the trailer box's own
// photos (see EditorFotoKendaraanSection.js), a separate group from the vehicle's own gambar_*.
export const vehicleOutlinePlaceholders = {
  gambar_depan: outlineDepan,
  gambar_kiri: outlineKiri,
  gambar_kanan: outlineKanan,
  gambar_belakang: outlineBelakang,
  gambar_box_depan: boxOutlineDepan,
  gambar_box_kiri: boxOutlineKiri,
  gambar_box_kanan: boxOutlineKanan,
  gambar_box_belakang: boxOutlineBelakang,
};
